import { render, staticRenderFns } from "./full-comparison-dialog.vue?vue&type=template&id=3c7a5c0a"
import script from "./full-comparison-dialog.vue?vue&type=script&lang=js"
export * from "./full-comparison-dialog.vue?vue&type=script&lang=js"
import style0 from "./full-comparison-dialog.vue?vue&type=style&index=0&id=3c7a5c0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports